import React from 'react';
import ErrorMessage from '../components/error-message';
import MetaTags from '../components/meta-tags';
import ErrorBoundary from '../components/error-boundary';
import { ScrollToTop } from '../components/scroll-to-top';

type Props = {
  status?: number;
  message?: string;
  stack?: string;
  metaTags: any;
  onRetry?: () => void;
  routeId: string;
  locationKey?: string;
};

const ErrorPage = ({
  status,
  message,
  stack,
  metaTags,
  onRetry,
  routeId,
  locationKey,
}: Props) => {
  return (
    <>
      <ScrollToTop key={locationKey}>
        <ErrorMessage
          status={status}
          message={message}
          stack={stack}
          onRetry={onRetry}
        />
      </ScrollToTop>
      <ErrorBoundary onError={() => null}>
        <MetaTags
          routeId={routeId}
          locationKey={locationKey}
          metaTags={metaTags}
        />
      </ErrorBoundary>
    </>
  );
};

export default ErrorPage;
